module.exports = require(36).PassThrough
